import * as React from 'react';
import { SVGProps } from 'react';

const IconLoadingSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.165 1.653c.071-.266-.087-.543-.36-.588a5 5 0 1 0 3.753 2.88c-.113-.252-.422-.333-.66-.195-.24.138-.319.443-.212.698a4 4 0 1 1-3.14-2.41c.273.037.547-.118.619-.385Z" />
  </svg>
);
export default IconLoadingSizeXs;
